import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { FaEdit, FaChartLine } from 'react-icons/fa';
import { PlusCircle } from 'lucide-react';
import Loading from '../components/Loading';
import ErrorToast from '../components/ErrorToast';
import Paginacao from '../components/Paginacao';
import './Campanhas.css';

const PAGE_SIZE = 12;

const CampanhaCard = ({ campanha }) => {
  const statusClass = `status-${campanha.status?.toLowerCase() || 'indefinido'}`;
  return (
    <div className="campanha-card">
      <div className="card-header">
        <h3 className="card-title">{campanha.nome}</h3>
        <span className={`status-tag ${statusClass}`}>{campanha.status || 'Indefinido'}</span>
      </div>
      <p className="card-description">{campanha.descricao || 'Sem descrição.'}</p>
      <div className="card-dates">
        <span><strong>Início:</strong> {campanha.data_inicio ? new Date(campanha.data_inicio).toLocaleDateString() : '-'}</span>
        <span><strong>Fim:</strong> {campanha.data_fim ? new Date(campanha.data_fim).toLocaleDateString() : '-'}</span>
      </div>
      <div className="card-footer">
        <Link to={`/campanhas/${campanha.id}/edit`} className="button-secondary icon-button">
          <FaEdit />
          <span>Editar</span>
        </Link>
        <Link to={`/campanhas/${campanha.id}/dashboard`} className="button-primary icon-button">
          <FaChartLine />
          <span>Ver Desempenho</span>
        </Link>
      </div>
    </div>
  );
};

const Campanhas = () => {
  const [campanhas, setCampanhas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [page, setPage] = useState(1);
  const [totalItens, setTotalItens] = useState(0);
  const navigate = useNavigate();

  const fetchCampanhas = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(`/campanhas`, {
        params: { page, pageSize: PAGE_SIZE }
      });
      setCampanhas(res.data.campanhas || []);
      setTotalItens(res.data.total || 0);
    } catch {
      setErro('Erro ao listar campanhas.');
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchCampanhas();
  }, [fetchCampanhas]);

  return (
    <div className="page-container campanhas-container">
      <div className="page-header">
        <h1 className="page-title">Campanhas</h1>
        <button
          className="button-primary add-btn"
          onClick={() => navigate('/campanhas/new')}
          title="Criar Nova Campanha"
        >
          <PlusCircle size={20} />
          <span>Nova Campanha</span>
        </button>
      </div>

      {erro && <ErrorToast message={erro} onClose={() => setErro('')} />}

      {loading ? (
        <Loading />
      ) : (
        <>
          {campanhas.length > 0 ? (
            <div className="campanhas-grid">
              {campanhas.map(c => (
                <CampanhaCard key={c.id} campanha={c} />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <p>Nenhuma campanha encontrada.</p>
              <p>Clique em "Nova Campanha" para começar.</p>
            </div>
          )}
          
          <Paginacao
            totalItens={totalItens}
            itensPorPagina={PAGE_SIZE}
            paginaAtual={page}
            setPaginaAtual={setPage}
          />
        </>
      )}
    </div>
  );
};

export default Campanhas;